import {Account} from "../../../../core/entities/account/domain/model/account.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AccountWithoutBookingActivatedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountWithoutBookingActivatedEvent';

  constructor(public readonly account?: Account) {
  }
}
